import React from 'react';
import { useT } from './BuilderApp.jsx';
import { ChevronLeft } from '../components/ui/Icons.jsx';

export default function SitePreviewModal({ url, onClose, onProceed }) {
  const t = useT();
  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 1000, background: '#050a14', display: 'flex', flexDirection: 'column' }}>
      {/* Top bar */}
      <div style={{
        display: 'flex', alignItems: 'center', gap: '1rem',
        padding: '.85rem 1.25rem',
        background: 'rgba(12,18,32,.9)',
        borderBottom: '1px solid rgba(255,255,255,.08)',
        backdropFilter: 'blur(20px)',
        flexShrink: 0,
      }}>
        <button className="btn btn-ghost btn-sm" onClick={onClose} style={{ gap: '.3rem', flexShrink: 0 }}>
          <ChevronLeft/> {t.modal_back}
        </button>
        <div style={{
          flex: 1, display: 'flex', alignItems: 'center', gap: '.6rem',
          background: 'rgba(255,255,255,.05)',
          border: '1px solid rgba(255,255,255,.09)',
          borderRadius: 9, padding: '.45rem .9rem',
          minWidth: 0,
        }}>
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <circle cx="6" cy="6" r="5" stroke="#34d399" strokeWidth="1.5"/>
            <path d="M4 6l1.5 1.5L8 4" stroke="#34d399" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <span style={{ fontSize: '.82rem', color: '#94a3b8', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {url}
          </span>
        </div>
        <button className="btn btn-primary btn-sm" onClick={onProceed} style={{ flexShrink: 0 }}>
          {t.modal_pay}
        </button>
      </div>

      {/* iframe content */}
      <div style={{ flex: 1, overflow: 'hidden', position: 'relative' }}>
        <iframe src={url} style={{ width: '100%', height: '100%', border: 'none' }} title="Your site preview"/>
      </div>
    </div>
  );
}
